import { ThemeUIStyleObject, getThemeValue } from "@theme/components";

export const phpBox: ThemeUIStyleObject = {
  width: "full",
  overflow: "hidden",
  mx: "auto",
  maxHeight: 500,
  borderLeft: (t) => `2px solid ${getThemeValue(t, "colors.white")}`,
  borderRight: (t) => `2px solid ${getThemeValue(t, "colors.white")}`,

  ":before": {
    content: "''",
    position: "absolute",
    top: 0,
    left: 0,
    width: "22vw",
    height: "screenHeight",
    background: "linear-gradient(to right, rgba(255,255,255,.8) 0%,rgba(255,255,255,0) 100%);",
    pointerEvents: "none",
    zIndex: 2,
  },
  ":after": {
    content: "''",
    position: "absolute",
    top: 0,
    right: 0,
    width: "22vw",
    height: "screenHeight",
    background: "linear-gradient(to left, rgba(255,255,255,.8) 0%,rgba(255,255,255,0) 100%);",
    pointerEvents: "none",
    zIndex: 2,
  },
  ".regular.slider": {
    display: "flex",
    maxWidth: 2000,
    height: "full",
    maxHeight: 500,
    mx: "auto",
    borderLeftColor: "white",
    borderLeftStyle: "solid",
  },
  ".regular.slider > div": {
    width: "33.33vw",
  },

  ".ghost-slider .slick-slide": {
    display: "flex",
    justifyContent: "center",
  },
  ".slick-slider": {
    position: "relative",
    width: "full",
    maxWidth: 2000,
    height: "full",
    maxHeight: 500,
    mx: "auto",
    li: {
      color: "gray",
      display: "flex",
      listStyle: "none",
    },
    ".slick-dots": {
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "black",
      width: 16,
      m: "0 auto",
    },
    ".slick-slide": {
      minWidth: [350, null, null, "unset"],
      width: [5350, null, null, "33.33vw"],
      maxHeight: 500,
      maxWidth: 500,
    },
    ".slick-slide > div": {
      width: "full",
      maxWidth: 500,
      height: "full",
      maxHeight: 500,
      bg: "white",
    },
    ".slick-list": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "full",
      height: "full",
      overflow: "hidden",
      p: 0,
      ".slick-track": {
        display: "flex",
        height: "full",
      },
      ".slick-list, .slick-track": {
        touchAction: "pan-y",
      },
    },
  },
};
